import * as googleAnalytics from 'services/google/analytics';
import Cookies from 'js-cookie';

export function init() {
  if(getEnabled() === true) {
    googleAnalytics.enable();
  }
}

export function getEnabled(): boolean|null {
  const acceptedStr = Cookies.get('analyticsCookiesAccepted');
  if(acceptedStr === true.toString()) {
    return true;
  } else if(acceptedStr === false.toString()) {
    return false;
  } else {
    return null;
  }
}

export function enable() {
  Cookies.set('analyticsCookiesAccepted', true.toString(), { expires: 365 });
  googleAnalytics.enable();
}

export function disable() {
  Cookies.set('analyticsCookiesAccepted', false.toString(), { expires: 365 });
  googleAnalytics.disable();
}

export function logPageView(path: string, title: string) {
  googleAnalytics.logPageView(path, title);
}